<template>
  <fragment>
    <slot />
    <v-divider />
    <FormSection class="pt-9" title="ENDEREÇO">
      <AddressFormSection v-model="value.endereco" v-on="$listeners" />
    </FormSection>
    <v-divider />
    <FormSection class="pt-9" title="DOCUMENTOS">
      <DocumentSelection v-bind="[$attrs, $props]" v-on="$listeners" />
    </FormSection>
  </fragment>
</template>

<script>
import FormSection from "@/components/FormSection.vue";
import AddressFormSection from "@/components/form/AddressFormSection.vue";
import DocumentSelection from "../components/form/DocumentSelection.vue";

export default {
  name: "NewCompanyForm",
  components: {
    FormSection,
    AddressFormSection,
    DocumentSelection
  },
  props: {
    value: Object
  }
};
</script>
